import { useState, useEffect } from "react";

const TaskFormValidation = (initialValues, validationRules) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  useEffect(() => {
    setValues(initialValues);
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Determine if the new value needs to be wrapped in an object
    const isCurrentValueObject = values ? typeof values[name] === "object" : "";
    const newValue = isCurrentValueObject ? { value } : value;

    setValues({ ...values, [name]: newValue });
    setTouched({ ...touched, [name]: true });
    validateField(name, newValue);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    const isCurrentValueObject = typeof values[name] === "object";
    const newValue = isCurrentValueObject ? { value } : value;

    setTouched({ ...touched, [name]: true });
    validateField(name, newValue);
  };

  const validateField = (name, value) => {
    const rule = validationRules[name];

    const actualValue = typeof value === "object" && value !== null ? value.value : value;

    if (rule) {
      let fieldErrors = [];
      if (Array.isArray(rule)) {
        fieldErrors = rule.map((ruleItem) => validateRule(ruleItem, actualValue));
      } else {
        fieldErrors.push(validateRule(rule, actualValue));
      }
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: fieldErrors.find((error) => error !== undefined) || undefined,
      }));
    }
  };

  const validateRule = (rule, value, subTaskFlad) => {
    const actualValue = typeof value === "object" && !Array.isArray(value) && value !== null ? value.value : value;
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return rule.errorMessage || "This field is required.";
      }
    } else {
      if (
        rule.required &&
        (String(actualValue)?.trim() === "" || String(actualValue)?.trim() === null || actualValue === undefined)
      ) {
        return rule.errorMessage || "This field is required.";
      }

      if (rule.email && actualValue && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(actualValue)) {
        return rule.errorMessage || "Invalid email format.";
      }
      if (rule.number && String(actualValue) && !/^\d+$/.test(actualValue)) {
        return rule.errorMessage || "Must be a number.";
      }

      if (rule.domain) {
        const domainRegex =
          /\.(com|net|org|edu|gov|biz|info|co|io|us|uk|in|au|ca|de|fr|jp|kr|ru|cn|br|mx|es|nl|ch|se|no|fi|dk|it|be|at)$/i;
        if (actualValue && !domainRegex?.test(actualValue)) {
          return rule.errorMessage || "Provide valid website URL.";
        }
      }

      if (rule.maxDigits && actualValue?.length > rule?.maxDigits) {
        return rule.errorMessage || `Must be between 1 to ${rule?.maxDigits} digits.`;
      }

      if (rule.minDigits && actualValue?.length < rule?.minDigits) {
        return rule.errorMessage || `Must be at least ${rule?.minDigits} digits.`;
      }

      if (rule.validationFn && !rule.validationFn(actualValue)) {
        return rule.errorMessage || "Invalid value.";
      }
    }

    return undefined;
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(validationRules).forEach((name) => {
      const rule = validationRules[name];
      const value = values[name];

      let fieldErrors = [];
      console.log("name,value", name, value);

      const actualValue = typeof value === "object" && !Array.isArray(value) && value !== null ? value?.value : value;
      if (name === "sub_tasks") {
        console.log("insidesub");

        // Reset fieldErrors to avoid duplicate entries
        fieldErrors = [];

        if (value?.length !== 0) {
          value?.map((item, index) => {
            // Ensure fieldErrors array has an object for each sub_task
            if (fieldErrors.length === 0) {
              fieldErrors.push({ subject: [], assigned_to: [] });
            }

            // Check for subject errors
            if (item.subject === "") {
              fieldErrors[0].subject.push({ value: index });
            } else {
              fieldErrors[0].subject.push({ value: "subjectFound" });
            }

            // Check for assigned_to errors
            if (item.assigned_to.length === 0) {
              fieldErrors[0].assigned_to.push({ value: index });
            } else {
              fieldErrors[0].assigned_to.push({ value: "assignedToFound" });
            }
          });
        }
      } else {
        // Handling other errors in the array or single rule validation
        if (Array.isArray(rule)) {
          fieldErrors = rule.map((ruleItem) => validateRule(ruleItem, actualValue));
        } else {
          fieldErrors.push(validateRule(rule, actualValue));
        }
      }

      // if (name === "sub_tasks") {
      //   console.log("insidesub");

      //   if (value.length !== 0) {
      //     value.map((item, index) => {

      //       if (fieldErrors.length === 0) {
      //         fieldErrors.push({ subject: [], assigned_to: [] });
      //       }

      //       if (item.subject === "") {
      //         fieldErrors[0].subject.push({ value: index });
      //       } else {

      //         fieldErrors[0].subject.push({ value: "subjectFound" });
      //       }

      //       if (item.assigned_to.length === 0) {
      //         fieldErrors[0].assigned_to.push({ value: index });
      //       } else {

      //         fieldErrors[0].assigned_to.push({ value: "assignedToFound" });
      //       }
      //     });
      //   }
      // }else{

      // if (Array.isArray(rule)) {
      //   fieldErrors = rule.map((ruleItem) => validateRule(ruleItem, actualValue));
      // } else {
      //   fieldErrors.push(validateRule(rule, actualValue));
      // }}

      newErrors[name] = fieldErrors || undefined;
    });

    setErrors(newErrors);
    return newErrors;
  };

  const isFormValid = () => {
    const formValidation = validateForm();
    return formValidation;
  };

  return {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    validateField,
    isFormValid,
  };
};

export default TaskFormValidation;
